/** https://form.typeform.com/to/kQ3rIaQq — UHPL Partnerships */
export const UHPL_PARTNERS_TYPEFORM_ID = 'kQ3rIaQq';

export const PL_PARTNERS_HERO = {
  desktop: 'web_v2/pl-partners/pl_partners.png',
  mobile: 'web_v2/pl-partners/pl_partners_mbl.png',
} as const;
